export default __webpack_public_path__ + "static/media/green-prev-arrow.85853cfb.svg";